// import LocalStorage from "../../utils/localStorage";
import customLayersJSON from "../../assets/customLayers/crypto2.json";

const retrieveCustomLayers = () => {
  // const customLayersFile = LocalStorage.getCustomLayersFile();
  // if (customLayersFile) return customLayersFile.data;

  // return null;

  return customLayersJSON;
};

export default retrieveCustomLayers;
